import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
} from '@backstage/theme';

import MyCustomFont from '../assets/fonts/Poppins-Regular.ttf';

const myCustomFont = {
    fontFamily: 'My-Custom-Font',
    fontStyle: 'regular',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `
      local('My-Custom-Font'),
      url(${MyCustomFont}) format('woff2'),
    `,
};

export const customTheme = createUnifiedTheme({
    fontFamily: 'My-Custom-Font',
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': [myCustomFont],
            },
        },
    },
    ...createBaseThemeOptions({
        palette: {
            ...palettes.dark,
            // primary: {
            //   main: '#ffffff',
            // },
            // secondary: {
            //   main: '#ffffff',
            // },
            // error: {
            //   main: '#ffffff',
            // },
            // warning: {
            //   main: '#ffffff',
            // },
            // info: {
            //   main: '#ffffff',
            // },
            // success: {
            //   main: '#ffffff',
            // },
            // banner: {
            //   info: '#34548a',
            //   error: '#8c4351',
            //   text: '#343b58',
            //   link: '#565a6e',
            // },
            // errorBackground: '#8c4351',
            // warningBackground: '#8f5e15',
            // infoBackground: '#343b58',
            background: {
                default: '#1D1D1B',
                paper: '#1D1D1B',
            },
            navigation: {
                background: '#330072',
                indicator: '#ffffff',
                color: '#d5d6db',
                selectedColor: '#ffffff',
                submenu: {
                    background: '#531DBC',
                },
                navItem: {
                    hoverBackground: "#440099"
                }
            },
        },
    }),
    defaultPageTheme: 'home',
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave }),
        documentation: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave, }),
        tool: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave }),
        service: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave, }),
        website: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave, }),
        library: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave, }),
        other: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave }),
        app: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave }),
        apis: genPageTheme({ colors: ['#6429CD', '#6429CD'], shape: shapes.wave }),
    },
});